/**
 * Para onde voltar depois do login.
 *
 * O destino vem da URL (`/entrar?destino=…`), e URL é entrada não confiável
 * mesmo num app de duas pessoas: é o parâmetro que um link recebido por
 * mensagem controla. Só caminho interno passa.
 *
 * `//outro.site` e `/\outro.site` são as duas formas de caminho que o
 * navegador resolve como endereço externo — a segunda porque `\` vale como `/`
 * na normalização de URL. As duas caem no padrão.
 */
export function safeDestination(destino: string | undefined): string {
  if (destino === undefined || destino === '') return '/'
  if (!destino.startsWith('/')) return '/'
  if (destino.startsWith('//') || destino.startsWith('/\\')) return '/'
  return destino
}
